import { isNullOrUndefined } from "../../../utils/funcUtils"

export class ArrayFilter {
  static arrayIncludes = (arr, value) => {
    return !isNullOrUndefined(arr) && arr.length > 0 ? arr.includes(value) : false
  }
}
